<template>
  <div class="alarm-timer-widget mt-2">
      <div class="display">
          {{ minutesLeft }}:{{ secondsLeftFormatted }}
      </div>
      <div class="preset-buttons">
          <button @click="setTimer(1)">1 min</button>
          <button @click="setTimer(2)">2 min</button>
          <button @click="setTimer(5)">5 min</button>
          <button @click="setTimer(10)">10 min</button>
      </div>
      <div class="control-buttons">
          <button :disabled="!isRunning && (timeLeft === 0 || timeLeft === totalTime)" @click="pauseTimer()">
              {{ this.isRunning ? 'Pause' : 'Start' }}
          </button>
          <button @click="resetTimer()">Reset</button>
      </div>
  </div>
</template>

<script>
export default {
  data() {
      return {
          totalTime: 0,  // Total time in seconds
          timeLeft: 0,   // Time left in seconds
          interval: null,
          isRunning: false
      };
  },
  computed: {
      minutesLeft() {
          return Math.floor(this.timeLeft / 60);
      },
      secondsLeftFormatted() {
          return (this.timeLeft % 60).toString().padStart(2, '0');
      }
  },
  methods: {
      setTimer(minutes) {
          this.totalTime = minutes * 60;
          this.timeLeft = this.totalTime;
          this.startTimer();
      },
      startTimer() {
          this.isRunning = true;
          if (this.timeLeft > 0 && !this.interval) {
              this.interval = setInterval(() => {
                  if (!this.isRunning) {
                      return;
                  }
                  if (this.timeLeft > 0) {
                      this.timeLeft--;
                  } else {
                      this.g2dialog.$alert('Alarm! Time is up!');
                      this.resetTimer();
                  }
              }, 1000);
          }
      },
      pauseTimer() {
          this.isRunning = !this.isRunning;
      },
      resetTimer() {
          clearInterval(this.interval);
          this.timeLeft = this.totalTime;
          this.interval = null;
          this.isRunning = false;
      }
  },
  beforeDestroy() {
      clearInterval(this.interval);
  }
}
</script>

<style scoped>
.alarm-timer-widget {
  width: 100%;
  border: 1px solid #ccc;
  padding: 10px;
  text-align: center;
}

.display {
  height: 30px;
  line-height: 30px;
  border: 1px solid #ccc;
  margin-bottom: 10px;
  background-color: #f9f9f9;
  font-size: 24px;
}

.preset-buttons, .control-buttons {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
}

button {
  width: 23%;
  height: 40px;
  background-color: #f9f9f9;
  border: 1px solid #ccc;
  font-size: 16px;
}
</style>
